import React, { Fragment, useState, useEffect, useRef } from 'react';
import Multiselect from 'multiselect-react-dropdown';
import BaasVaasConfig from '../../models/BaasVaasConfig';
import { getApi } from '../../api/endpoints';
import { toast } from 'react-toastify';

const FormPartial = (props) => {
  const { baasVaasConfig, setBaasVaasConfig } = props;
  let baasVaasConfigObj = new BaasVaasConfig(baasVaasConfig);

  const [selectedChildServiceTypes, setSelectedChildServiceTypes] = useState([])
  const [selectedParentServiceTypes, setSelectedParentServiceTypes] = useState([])

  const [branchesApi] = getApi('branches');
  const [branches, setBranches] = useState([]);

  const [userTypesApi] = getApi('usersTypes');
  const [userTypes, setUserTypes] = useState([]);

  const [headUsersApi] = getApi('users');
  const [headUsers, setHeadUsers] = useState([]);

  const [serviceTypeApi] = getApi('serviceType');
  const [serviceType, setServiceType] = useState([]);

  const [childServiceType, setChildServiceType] = useState([]);

  const usersRef = useRef();
  const childServiceTypesRef = useRef();

  useEffect(() => {
    fetchCircles();
    fetchUserTypes();
    fetchServiceTypes(true);
  }, []);

  useEffect(() => {
    if(selectedParentServiceTypes != []) {
      fetchServiceTypes();  
    }
  }, [selectedParentServiceTypes])

  const fetchServiceTypes = async (parent_service_types = false) => {
    try {
      if(parent_service_types) {
        const response = await serviceTypeApi({ filters: { parent_ids: [0] } }).unwrap();
        setServiceType(response.data.service_types);
      } else if(selectedParentServiceTypes.length !== 0){
        const response = await serviceTypeApi({ filters: { parent_ids: selectedParentServiceTypes } }).unwrap();
        setChildServiceType(response.data.service_types);
      }
    } catch (error) {
      toast.error(error.data.message || "Something went wrong")
    }
  }

  const fetchCircles = async () => {
    try {
      const response = await branchesApi({ fields: 'options' }).unwrap();
      setBranches(response.data.branches);
    } catch (error) {
    }
  }

  const fetchUserTypes = async () => {
    try {
      const response = await userTypesApi({ filters: { head_users_types: true }}).unwrap();
      setUserTypes(response.data.users_types);
    } catch (error) {
    }
  }

  const fetchUsers = async (branch_ids, users_type_ids) => {
    try {
      const response = await headUsersApi({ filters:{ branch_ids: branch_ids, users_type_ids: users_type_ids } }).unwrap();
      setHeadUsers(response.data.users);
    } catch (error) {
    }
  }

  const validateValue = (field) => {
    baasVaasConfigObj.validate(field);
  }

  const onSelectCircle = (selectedList, selectedItem) => {
    baasVaasConfigObj.branch_id = selectedItem.id;
    validateValue('branch_id');
    if( baasVaasConfigObj.branch_id !== "" &&  baasVaasConfigObj.user_type_id !== ""){
      fetchUsers([baasVaasConfigObj.branch_id], [baasVaasConfigObj.user_type_id]);
    } else{
      setHeadUsers([]);
      baasVaasConfigObj.user_ids = [] ;
      usersRef.current.resetSelectedValues();
    }
    setBaasVaasConfig(baasVaasConfigObj.toStateJson());
  }

  const onRemoveCircle = (selectedList, removedItem) => {
    baasVaasConfigObj.branch_id = "";
    validateValue('branch_id');
    if( baasVaasConfigObj.branch_id !== "" &&  baasVaasConfigObj.user_type_id !== ""){
      fetchUsers([baasVaasConfigObj.branch_id], [baasVaasConfigObj.user_type_id]);
    } else{
      setHeadUsers([]);
      baasVaasConfigObj.user_ids = [];
      usersRef.current.resetSelectedValues();
    }
    setBaasVaasConfig(baasVaasConfigObj.toStateJson());
  }

  const onSelectUserType = (selectedList, selectedItem) => {
    baasVaasConfigObj.user_type_id = selectedItem.id;
    validateValue('user_type_id');
    if( baasVaasConfigObj.branch_id !== "" &&  baasVaasConfigObj.user_type_id !== ""){
      fetchUsers([baasVaasConfigObj.branch_id], [baasVaasConfigObj.user_type_id]);
    } else{
      setHeadUsers([]);
      baasVaasConfigObj.user_ids = [];
      usersRef.current.resetSelectedValues();
    }
    setBaasVaasConfig(baasVaasConfigObj.toStateJson());
  }

  const onRemoveUserType = (selectedList, removedItem) => {
    baasVaasConfigObj.user_type_id = "";
    validateValue('user_type_id');
    if( baasVaasConfigObj.branch_id !== "" &&  baasVaasConfigObj.user_type_id !== ""){
      fetchUsers([baasVaasConfigObj.branch_id], [baasVaasConfigObj.user_type_id]);
    } else{
      setHeadUsers([]);
      baasVaasConfigObj.user_ids = [];
      usersRef.current.resetSelectedValues();
    }
    setBaasVaasConfig(baasVaasConfigObj.toStateJson());
  }

  const onSelectUser = (selectedList, selectedItem) => {
    baasVaasConfigObj.user_ids.push(selectedItem.id);
    validateValue('user_ids');
    setBaasVaasConfig(baasVaasConfigObj.toStateJson());
  }

  const onRemoveUser = (selectedList, removedItem) => {
    baasVaasConfigObj["user_ids"] = baasVaasConfig.user_ids.filter((id) => id != removedItem.id)
    validateValue('user_ids');
    setBaasVaasConfig(baasVaasConfigObj.toStateJson());
  }

  const onSelectServiceType = (selectedList, selectedItem) => {
    setSelectedParentServiceTypes((prevState)=> {
      return [...prevState, selectedItem.id]
    })
  }

  const onRemoveServiceType = async (selectedList, removedItem) => {
    let filteredSelectedServiceTypes = childServiceTypesRef.current.getSelectedItems().filter(selectedItem => selectedItem.parent_id != removedItem.id )
    await setSelectedChildServiceTypes(filteredSelectedServiceTypes);
    baasVaasConfigObj['child_service_types'] = filteredSelectedServiceTypes.map(item => item.id)
    setSelectedParentServiceTypes((prevState)=> {
      return prevState.filter((id) => id != removedItem.id)
    })
    setBaasVaasConfig(baasVaasConfigObj.toStateJson());
  }

  const onSelectChildServiceType = (selectedList, selectedItem) => {
    baasVaasConfigObj.child_service_types.push(selectedItem.id)
    setSelectedChildServiceTypes((prevState) => [...prevState, selectedItem])
    validateValue('child_service_types');
    setBaasVaasConfig(baasVaasConfigObj.toStateJson());
  }

  const onRemoveChildServiceType = (selectedList, removedItem) => {
    baasVaasConfigObj['child_service_types'] = baasVaasConfig.child_service_types.filter((id)=> id != removedItem.id)
    validateValue('child_service_types');
    setBaasVaasConfig(baasVaasConfigObj.toStateJson());
  }

  const nameIDCombination = (arr, combKey_1 = "id", combKey_2 = "name") => {
    let combination = arr.map((item)=>{
      return { ...item, name: `${item[combKey_1]} - ${item[combKey_2]}`} 
    })
    return combination
  }

  return <Fragment>
    <div className="col-md-4 mb-0">
      <label htmlFor="branch_id" className="form-label mb-0">Select Circle</label>
      <Multiselect
        id='branch_id'
        options={branches}
        avoidHighlightFirstOption={true}
        singleSelect={true}
        onSelect={(selectedList, selectedItem) => onSelectCircle(selectedList, selectedItem)}
        onRemove={(selectedList, removedItem) => onRemoveCircle(selectedList, removedItem)}
        placeholder="Select Circle"
        displayValue={'name'}
        showArrow={true}
        customArrow={true}
      />
      <div id="branch_id_help" className="form-text text-danger mt-0">
        {baasVaasConfigObj.errors.branch_id}
      </div>
    </div>

    <div className="col-md-4 mb-0">
      <label htmlFor="user_type_id" className="form-label mb-0">Select User Type</label>
      <Multiselect
        id='user_type_id'
        options={userTypes}
        avoidHighlightFirstOption={true}
        singleSelect={true}
        onSelect={(selectedList, selectedItem) => onSelectUserType(selectedList, selectedItem)}
        onRemove={(selectedList, removedItem) => onRemoveUserType(selectedList, removedItem)}
        placeholder="Select User Type"
        displayValue={'role_name'}
        showArrow={true}
        customArrow={true}
      />
      <div id="user_type_id_help" className="form-text text-danger mt-0">
        {baasVaasConfigObj.errors.user_type_id}
      </div>
    </div>

    <div className="col-md-4 mb-0">
      <label htmlFor="user_ids" className="form-label mb-0">Select User</label>
      <Multiselect
        id='user_ids'
        options={nameIDCombination(headUsers)}
        onSelect={(selectedList, selectedItem) => onSelectUser(selectedList, selectedItem)}
        onRemove={(selectedList, removedItem) => onRemoveUser(selectedList, removedItem)}
        placeholder="Select User"
        displayValue={'name'}
        showArrow={true}
        customArrow={true}
        disable={baasVaasConfigObj.branch_id === "" || baasVaasConfigObj.user_type_id === ""}
        ref={usersRef}
      />
      <div id="user_ids_help" className="form-text text-danger mt-0">
        {baasVaasConfigObj.errors.user_ids}
      </div>
    </div>

    <div className="col-md-4 mb-0">
      <label htmlFor="service_type_id" className="form-label mb-0">Select Parent Service Type</label>
      <Multiselect
        id='service_type_id'
        options={serviceType}
        avoidHighlightFirstOption={true}
        onSelect={(selectedList, selectedItem) => onSelectServiceType(selectedList, selectedItem)}
        onRemove={(selectedList, removedItem) => onRemoveServiceType(selectedList, removedItem)}
        placeholder="Select Service Type"
        displayValue={'name'}
        showArrow={true}
        customArrow={true}
      />
      <div id="service_type_id_help" className="form-text text-danger mt-0">
        {baasVaasConfigObj.errors.service_type_id}
      </div>
    </div>

    <div className="col-md-4 mb-0">
      <label htmlFor="child_service_types" className="form-label mb-0">Select Child Service Type</label>
      <Multiselect
        id='child_service_types'
        selectedValues={selectedChildServiceTypes}
        options={nameIDCombination(childServiceType, "parent_name", "name")}
        avoidHighlightFirstOption={true}
        onSelect={(selectedList, selectedItem) => onSelectChildServiceType(selectedList, selectedItem)}
        onRemove={(selectedList, removedItem) => onRemoveChildServiceType(selectedList, removedItem)}
        placeholder="Select Child Service Type"
        displayValue={'name'}
        showArrow={true}
        customArrow={true}
        ref={childServiceTypesRef}
      />
      <div id="child_service_type_help" className="form-text text-danger mt-0">
        {baasVaasConfigObj.errors.child_service_types}
      </div>
    </div>
    
  </Fragment >
}

export default FormPartial;
